import { render, staticRenderFns } from "./IconTrashCan.vue?vue&type=template&id=5ef162e5&"
import script from "./IconTrashCan.vue?vue&type=script&lang=js&"
export * from "./IconTrashCan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports